import { render } from "./AlertsPanel.vue?vue&type=template&id=477f06c4"
import script from "./AlertsPanel.vue?vue&type=script&lang=js"
export * from "./AlertsPanel.vue?vue&type=script&lang=js"

import "./AlertsPanel.vue?vue&type=style&index=0&id=477f06c4&lang=scss"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__